var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#fff",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 26.25s-1.375 0-1.375-1.375 1.375-5.5 8.25-5.5 8.25 4.125 8.25 5.5-1.375 1.375-1.375 1.375h-13.75zM18 18a4.125 4.125 0 100-8.25A4.125 4.125 0 0018 18z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml,%3csvg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='36' height='36' rx='18' fill='white' fill-opacity='0.1'/%3e %3cpath d='M11.125 26.25C11.125 26.25 9.75 26.25 9.75 24.875C9.75 23.5 11.125 19.375 18 19.375C24.875 19.375 26.25 23.5 26.25 24.875C26.25 26.25 24.875 26.25 24.875 26.25H11.125ZM18 18C19.094 18 20.1432 17.5654 20.9168 16.7918C21.6904 16.0182 22.125 14.969 22.125 13.875C22.125 12.781 21.6904 11.7318 20.9168 10.9582C20.1432 10.1846 19.094 9.75 18 9.75C16.906 9.75 15.8568 10.1846 15.0832 10.9582C14.3096 11.7318 13.875 12.781 13.875 13.875C13.875 14.969 14.3096 16.0182 15.0832 16.7918C15.8568 17.5654 16.906 18 18 18Z' fill='white'/%3e %3c/svg%3e";
export { SvgOutlinedProfile as ReactComponent };